export default __webpack_public_path__ + "static/front_house_1-15f3084d7332ab229b5ae5c253780c5c.jpg";